import * as React from 'react';
import Svg, {
  SvgProps, G, Rect, Path, Defs, ClipPath,
} from 'react-native-svg';
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const NoBuildingsIconMobile = (props: SvgProps) => (
  <Svg
    width={375}
    height={324}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Rect width={280} height={324} x={46.5} fill="#E6EEF7" rx={24} />
      <G filter="url(#b)">
        <Rect
          width={104.409}
          height={101}
          x={246.5}
          y={170}
          fill="#fff"
          rx={6.819}
        />
        <Rect
          width={103.983}
          height={100.574}
          x={246.713}
          y={170.213}
          stroke="#EEF4FA"
          strokeWidth={0.426}
          rx={6.605}
        />
        <Path
          fill="#B0CBE6"
          d="M318.947 259.92v-67.333c0-.471.382-.853.853-.853h9.375c.471 0 .852.382.852.853v67.333h-11.08Z"
        />
        <Path
          fill="#548FC8"
          d="M301.049 259.92v-68.612c0-.471.381-.852.852-.852h9.376c.47 0 .852.381.852.852v68.612h-11.08Z"
        />
        <Path
          fill="#B0CBE6"
          d="M283.149 259.92v-69.89c0-.471.382-.853.853-.853h9.375c.471 0 .853.382.853.853v69.89h-11.081ZM265.251 259.92v-72.021c0-.471.382-.852.852-.852h9.376c.471 0 .852.381.852.852v72.021h-11.08Z"
        />
      </G>
      <G filter="url(#c)">
        <Rect width={172} height={192} x={24.5} y={100} fill="#fff" rx={16} />
        <Rect
          width={171}
          height={191}
          x={25}
          y={100.5}
          stroke="#EEF4FA"
          rx={15.5}
        />
        <Path
          fill="#B0CBE6"
          d="M40.5 118.963c0-1.636 1.79-2.963 4-2.963h98c2.209 0 4 1.327 4 2.963v14.074c0 1.636-1.791 2.963-4 2.963h-98c-2.21 0-4-1.327-4-2.963v-14.074Z"
        />
        <Path
          stroke="#548FC8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={4}
          d="m40.5 276 7.013-16.338L61.5 247.5H77L88.711 200 99 212l15-31 18.5 44.352L148 238.5l13-13.148L172.5 197l11.5-25.5"
        />
      </G>
      <G filter="url(#d)">
        <Rect width={132} height={132} x={123} y={10} fill="#fff" rx={66} />
        <Path
          fill="#B0CBE6"
          d="M160.516 63.931a5.558 5.558 0 0 1 5.558-5.557h46.547a5.558 5.558 0 0 1 5.558 5.557v23.621a5.558 5.558 0 0 1-5.558 5.558h-46.547a5.558 5.558 0 0 1-5.558-5.558v-23.62Z"
        />
        <G filter="url(#e)">
          <Path
            fill="#F8FAFB"
            d="M247.358 76c0 32.23-26.127 58.358-58.358 58.358-32.23 0-58.357-26.128-58.357-58.358S156.77 17.642 189 17.642c32.231 0 58.358 26.128 58.358 58.358Zm-106.329 0c0 26.494 21.478 47.971 47.971 47.971 26.494 0 47.972-21.477 47.972-47.971 0-26.494-21.478-47.971-47.972-47.971-26.493 0-47.971 21.477-47.971 47.971Z"
          />
        </G>
        <Path
          fill="#548FC8"
          d="M246.382 76c0 31.691-25.691 57.382-57.382 57.382-31.69 0-57.381-25.691-57.381-57.382 0-31.69 25.691-57.38 57.381-57.38 31.691 0 57.382 25.69 57.382 57.38Zm-106.27 0c0 27.001 21.888 48.889 48.888 48.889 27.001 0 48.889-21.888 48.889-48.889 0-27-21.888-48.888-48.889-48.888-27 0-48.888 21.888-48.888 48.888Z"
        />
      </G>
      <G filter="url(#f)">
        <Path
          fill="#fff"
          d="M298.783 16c9.351 0 16.293 10.862 18.595 16.293H268.5c2.975-11.731 12.928-7.785 17.532-4.345.354-3.983 6.376-11.948 12.751-11.948Z"
        />
      </G>
      <G filter="url(#g)">
        <Path
          fill="#fff"
          d="M311.5 157c-4.38-10.333-17.589-31-35.38-31-11.631 0-74.225 10.992-30.503 21.396-12.351-.454-25.025 1.355-27.117 9.604h93Z"
        />
      </G>
      <G filter="url(#h)">
        <Path
          fill="#fff"
          d="M86.783 35c9.35 0 16.293 10.862 18.595 16.293H56.5c2.975-11.731 12.928-7.785 17.532-4.345C74.386 42.965 80.408 35 86.783 35Z"
        />
      </G>
      <G filter="url(#i)">
        <Path
          fill="#fff"
          d="M221.72 284c-27.587 0-53.428 10.948-60.22 27h213c-8.778-34.673-67.708-23.008-81.292-12.842C276.736 287.355 240.529 284 221.72 284Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h375v324H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default NoBuildingsIconMobile;
